import addEmailToListRouteData from "./add-email-to-list-route";
import addUserToWaitlistRouteData from "./add-user-to-waitlist-route";
import getEmailListRouteData from "./get-email-list-route";
import getAllEmailListsRouteData from "./get-all-email-lists-route";
import editEmailItemRouteData from "./edit-email-item-route";
import approveUserOnWaitlistRouteData from "./approve-user-on-waitlist-route";

export default {
  "add-email-to-list": addEmailToListRouteData,
  "add-user-to-waitlist": addUserToWaitlistRouteData,
  "get-email-list": getEmailListRouteData,
  "get-all-email-lists": getAllEmailListsRouteData,
  "edit-email-item": editEmailItemRouteData,
  "approve-user-on-waitlist": approveUserOnWaitlistRouteData,
};
